/**
 * TelemetryService.js
 * Created by calhosh on 8/28/2020.
 */
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {ReactPlugin} from '@microsoft/applicationinsights-react-js';
let reactPlugin = null;
let appInsights = null;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
	/**
	 * Initialize the Application Insights class
	 * @param {string} instrumentationKey - Application Insights Instrumentation Key
	 * @return {void}
	 */
	const initialize = (instrumentationKey) => {
		if (!instrumentationKey) {
			console.log('Instrumentation key is not present in config file for specific environment');
		}

		reactPlugin = new ReactPlugin();

		appInsights = new ApplicationInsights({
			config: {
				instrumentationKey: instrumentationKey,
				maxBatchInterval: 0,
				disableAjaxTracking: true, //
				disableFetchTracking: true,
				extensions: [reactPlugin],
				enableAutoRouteTracking: true
			}
		});

		appInsights.loadAppInsights();
	};

	return {reactPlugin, appInsights, initialize};
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
